<template>
  <div class="yingyong">
      <div class="inner">
        <div class="pub-title">
          <span>{{ $t('experience') }}</span>
        </div>
        <div class="content">
          <div class="item" v-for="(item, index) in list" :key="index" @click="turnDetail(item, index)">
              <img class="img" :src="item.coverPc" alt="">
              <div class="text">
                <div class="title ellipsis2">{{ item['title' + En] }}</div>
                <div class="addr">
                  <div class="addr-item">
                    <img src="https://static.worldaic.com.cn/2024/web/static/images/clock.png" alt="">
                    <span>{{ item.releaseTime }}</span>
                  </div>
                  <div class="addr-item">
                    <img src="https://static.worldaic.com.cn/2024/web/static/images/addr.png" alt="">
                    <span>{{ item['addr' + En] }}</span>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="pageNum"
          :page-size="10"
          :layout="pageLayout"
          :pager-count="isPc ? 7 : 3"
          :total="total">
        </el-pagination>
      </div>
  </div>
</template>

<script>
import protal from "@/api/protal";

export default {
  name: 'yingyong',
  data() {
    return {
      list: [],
      currentPage: 0,
      pageNum: 1,
      total: 0
    }
  },
  created() {
    this.pageView('gw_yingyongpage')
    this.getData()
  },

  methods: {
    async turnDetail(item, index) {
      // console.log(item.dataTagRes, '标签')
      // let arr = item.dataTagRes || []
      // arr = arr.map(x => x.dataTag)
      // let industryFirstCate_var = this.labels.filter(x => arr.includes(x.uuid)).map(x => x.lableDesc).join('|')
      this.$jsAPI('track','applyExperience',
          {
            'contentName_var': item.title,
            // 'industryFirstCate_var': industryFirstCate_var ? '|' + industryFirstCate_var + '|' : '无',
            // 'industrySecCate_var': '无',
            'industryFirstCate_var': this.getFirstLabel(item.dataTagTwoRes),
            'industrySecCate_var': await this.getSecLabel(item.dataTagTwoRes),
            'position_var': `${this.pageNum}-${index + 1}`,
            'contentid': item.uuid
          }
      );
      gio('track','applyExperience',
          {
            'contentName_var': item.title,
            'industryCate_var': this.getFirstLabel(item.dataTagTwoRes),
            'industryFirstCate_var': await this.getSecLabel(item.dataTagTwoRes),
            'position_var': `${this.pageNum}-${index + 1}`
          }
      );
      
      this.publink('cjdetail', item)
    },
    handleCurrentChange(v) {
      this.pageNum = v
      this.getData()
    },
    getData() {
      const params = {
        "pageNum": this.pageNum,
        "pageSize": 6,
        "creativeType": 2,
      }
      protal.queryOfficialCreativeList(params).then(res => {
        this.list = res.data || []
        this.total = res.total || 0
      })
    },
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .yingyong {
    background-image: url(https://static.worldaic.com.cn/2024/web/static/images/dahui-bg.jpg);
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  
}
</style>



// WEBPACK FOOTER //
// src/pages/yingyong/index.vue